import React, { memo } from 'react'
import { SmartWayCarrierModal } from 'transfix-form/forms/SmartWayCarrier/components'
import {
  getSmartWayCarrierDefaultValues,
  getSmartWayCarrierLabels,
} from 'transfix-form/forms/SmartWayCarrier/utils'
import Card from 'transfix-ui/components/Card'
import { Box } from 'transfix-ui/core'
import Typography from 'transfix-ui/core/Typography'
import { Maybe } from 'types/graphqlTypes'
import { useModalState } from 'utils/hooks/useModalState'
import SidebarCardRow from '../SidebarCardRow'
import { ICarrierProfileSmartWayRegistrationFragment } from './graphql/CarrierProfileSmartWayRegistrationFragment'
import { useSmartWayCarrierSubmitter } from './hooks'

export interface ISmartWayCarrierCardProps {
  carrierApplicationId: string
  smartWayRegistration: Maybe<ICarrierProfileSmartWayRegistrationFragment['smartWayRegistration']>
}

const SmartWayCarrierCard = memo<ISmartWayCarrierCardProps>(
  ({ carrierApplicationId, smartWayRegistration }) => {
    const {
      createToggleHandler,
      modalState: { smartWayCarrierModal: isSmartWayCarrierModalOpen },
    } = useModalState({
      smartWayCarrierModal: false,
    })

    const toggleSmartWayCarrierModal = createToggleHandler('smartWayCarrierModal')
    const { loading, submitHandler } = useSmartWayCarrierSubmitter(
      carrierApplicationId,
      smartWayRegistration?.id
    )
    const defaultValues = getSmartWayCarrierDefaultValues(smartWayRegistration)
    const { registeredLabel, renewalDateLabel } = getSmartWayCarrierLabels(smartWayRegistration)

    return (
      <Card>
        <Typography variant='h3'>SmartWay Carrier</Typography>
        <Box mt={1}>
          <SidebarCardRow
            title='Is this a SmartWay carrier?'
            value={
              <>
                <Typography component='div' variant='body1'>
                  {registeredLabel}
                </Typography>
                <Typography component='div' variant='body1' color='textSecondary'>
                  {renewalDateLabel}
                </Typography>
              </>
            }
            onEdit={toggleSmartWayCarrierModal}
          />
        </Box>

        {isSmartWayCarrierModalOpen && (
          <SmartWayCarrierModal
            defaultValues={defaultValues}
            loading={loading}
            onClose={toggleSmartWayCarrierModal}
            onSubmit={submitHandler}
          />
        )}
      </Card>
    )
  }
)

export default SmartWayCarrierCard
